import { useEffect, useState } from "react";
import ServiceAgreementCreateDialog from "./ServiceAgreementCreateDialog";
import { useTranslation } from "react-i18next";
import { ServiceAgreementSimpleForm } from "./simple-form";
import {
  fetchServiceAgreement,
  fetchServiceAgreementSetup,
} from "../../../../api/service/agreement";
import { PMDialog } from "../../../utils/PMDialog";
import { ServiceAgreementSetupGuide } from "./setup-guide";

export default function ServiceAgreementModal(props) {
  return props.selected?.id ? <AgreementEditModal {...props} /> : <ServiceAgreementCreateDialog {...props} />;
}

function AgreementEditModal(props) {
  const { t } = useTranslation();
  const { open, onClose, selected, customer } = props;

  const [itemState, setItemState] = useState({
    isLoading: true,
    error: false,
    errors: [],
    agreement: {},
  });
  const [setup, setSetup] = useState(null);

  const { agreement, isLoading } = itemState;
  const creating = !selected?.id;
  const setupBlocked = creating && setup && setup.ready === false;

  const getServiceAgreement = async () => {
    await fetchServiceAgreement(selected.id)
      .then((res) => {
        if (res.data.id) {
          setItemState((prevState) => ({
            ...prevState,
            isLoading: false,
            agreement: res.data,
          }));
        }
      })
      .catch(() => {
        setItemState((prevState) => ({
          ...prevState,
          isLoading: false,
          report: {},
          error: true,
          errors: null,
        }));
      });
  };

  useEffect(() => {
    if (open) {
      setItemState((prevState) => ({
        ...prevState,
        isLoading: true,
      }));
      setSetup(null);
      if (selected?.id) {
        getServiceAgreement();
      } else {
        fetchServiceAgreementSetup()
          .then((data) => {
            setSetup(data);
            setItemState((prevState) => ({
              ...prevState,
              isLoading: false,
            }));
          })
          .catch(() => {
            setItemState((prevState) => ({
              ...prevState,
              isLoading: false,
            }));
          });
      }
    } else {
      setItemState((prevState) => ({
        ...prevState,
        report: {},
      }));
    }
  }, [open]);

  if (setupBlocked) {
    return (
      <ServiceAgreementSetupGuide
        open={open}
        onClose={onClose}
        setup={setup}
        blockCreate
      />
    );
  }

  return (
    <PMDialog
      isLoading={isLoading}
      open={open}
      onClose={onClose}
      title={
        agreement?.id
          ? t("service.agreements.modal.update")
          : t("service.agreements.modal.create")
      }
    >
      <ServiceAgreementSimpleForm
        item={agreement}
        onClose={onClose}
        customer={customer}
        {...props}
      />
    </PMDialog>
  );
}
